export const hasSelectedCardText = (selectedText: string | null | undefined): boolean => Boolean(selectedText?.trim());
